import {LANGUAGE} from '@/common/utils/constants';

export const CONTROL_PANEL_TRANSLATIONS = {
	[LANGUAGE.en.short]: {
		landingPage: {
			title: 'Landing Page',
			imageUploadTitle: 'Change the landing page image',
			imageHint: `The image must be with very good quality in webp format, height between 1065px - 858px and width between 1728px - 1280px.`,
			label: `Upload your image and click on the Apply button`,
			apply: 'Apply',
			errors: {
				width: 'The image does not have a width between 1728px and 1280px.',
				height: 'The image does not have a height between 1065px and 858px.',
				imageType: 'The image is not correct file type.',
				fileType: 'The file is not correct type.',
				notEmpty: `The field cannot be empty.`,
				notValidUrl: 'It is not a valid URL.',
				notValidEmail: 'It is not a valid email.',
				notValidLength: 'The field must be between {min} and {max} symbols.',
				notValidWidth: 'The image does not have at least {min}px width.',
				notValidHeight: 'The image does not have at least {min}px height.',
				notEnoughSelected: 'You must select at least {min} options.',
				tooMuchSelected: 'You must select maximum {max} options.',
				dimensions: 'The image does not have the correct dimensions. Should be 1920x535 or 1200x338.',
				mobileDimensions: 'The image does not have the correct dimensions. Should be 480x400 or 460x400.',
				notUnique: 'There cannot be repeating items.',
				maxLength: 'The field must be no more than {max} symbols.',
				failToGenerateMonthlyReport: `Fail to generate a report for the period:`
			},
			changeVersion: 'Update the application version',
			updateVersionButton: 'update version',
			autoCleanCacheLabel: 'By clicking this button you can change the application version for all users.',
			autoCleanCacheHint: 'It will auto-clean the cache of all users and will reload the web page',
			newsletterSection: 'Update news',
			newsletterLabel: 'Here you can create, edit, and delete news',
			newsletterTip: 'Drag and drop the news to change their display order',
			buttons: {
				create: "Create news",
				delete: "Delete",
				edit: "Edit",
				saveOrder: "Save the news order",
				close: 'Close',
				save: "Save",
				archive: "Archive",
				unarchive: "Unarchive",
				promote: "Promote",
				monthlyReport: 'Monthly report'
			},
			selectPlatformForm: 'Select a platform type:',
			topicForm: 'Topic:',
			titleForm: 'Title:',
			messageForm: 'Message:',
			redirectButtonForm: 'Redirect button text:',
			redirectButtonUrlForm: 'Redirect URL:',
			commonHintForm: 'This field is mandatory, should be only in English, and must have text length between {min} and {max} symbols.',
			redirectButtonHintForm: 'This field is mandatory and must have text length between {min} and {max} symbols.',
			selectHintForm: 'This field is mandatory. You must select one of both options.',
			exampleTopic: 'Example topic...',
			exampleTitle: 'Example title...',
			exampleMessage: 'Example message...',
			exampleButtonRedirect: 'Example redirect button text...',
			successfullyGeneratedMonthlyReport: 'Successfully generated report for the period:',
			mustSelectDates: 'You have to select start and end dates from the date filter to generate the Monthly report'
		},
		manageLabels: 'Manage Labels',
		usersManagement: {
			title: 'Manage Users',
			form: {
				id: 'ID',
				fullName: 'Full Name',
				email: 'Email',
				company: 'Company',
				jobTitle: 'Job Title',
				createdDate: 'Created Date',
				requestDate: 'Request Date',
				lastLoginDate: 'Last Login Date',
				status: 'Status',
				actions: 'Actions',
			},
			popUp: {
				areYouSureApprove: "Are you sure you want to approve the user - ",
				areYouSureSetPending: " - will not be able to sign-in. Are you sure?",
				yes: "Yes",
				no: "No"
			},
			successApprove: "The user was successfully approved.",
			successPending: "The user was successfully set to pending.",
			successUnhalted: "The user was successfully unhalted.",
			successHalted: "The user was successfully halted.",
			approve: "Approve",
			setToPending: "Set to pending",
			setToUnhalted: 'Set to unhalted',
			setToHalted: "Set to halted",
			failedEmailToApprovedUser: 'Failed to send an email to the approved user.'
		},
		surveyManagement: {
			title: 'Manage Surveys',
		},
		videoManagement:{
			title: 'Manage Videos',
		},
		resourceFileManagement: {
			title: 'Manage Resource Files',
		},
		promotionsManagement: {
			title: 'Manage Promotions',
		},
		analytics: {
			title: 'Reporting'
		}
	},
	[LANGUAGE.de.short]: {
		landingPage: {
			title: 'Landingpage',
			imageUploadTitle: 'Ändern Sie das Landingpage-Bild',
			imageHint: `Das Bild muss von sehr guter Qualität im WebP-Format sein, mit einer Höhe zwischen 1065px und 858px und einer Breite zwischen 1728px und 1280px.`,
			label: `Laden Sie Ihr Bild hoch und klicken Sie auf die Schaltfläche „Übernehmen“.`,
			apply: 'Anwenden',
			errors: {
				width: 'Das Bild hat keine Breite zwischen 1728px und 1280px.',
				height: 'Das Bild hat keine Höhe zwischen 1065px und 858px.',
				imageType: 'Das Bild hat nicht den richtigen Dateityp.',
				fileType: 'Die Datei hat nicht den richtigen Dateityp.',
				notEmpty: `Das Feld darf nicht leer sein.`,
				notValidUrl: 'Es handelt sich nicht um eine gültige URL.',
				notValidEmail: 'Es handelt sich nicht um eine gültige E-Mail-Adresse.',
				notValidLength: 'Das Feld muss zwischen {min} und {max} Symbolen liegen.',
				notValidWidth: 'Das Bild hat nicht mindestens {min}px Breite.',
				notValidHeight: 'Das Bild hat nicht mindestens {min}px Höhe.',
				notEnoughSelected: 'Sie müssen mindestens {min} Optionen auswählen.',
				tooMuchSelected: 'Sie müssen maximal {max} Optionen auswählen.',
				dimensions: 'Das Bild hat nicht die richtigen Abmessungen. Sollte 1920x535 oder 1200x338 sein.',
				mobileDimensions: 'Das Bild hat nicht die richtigen Abmessungen. Sollte 480x400 oder 460x400 sein.',
				notUnique: "Es dürfen keine wiederholten Elemente vorhanden sein.",
				maxLength: 'Das Feld darf nicht mehr als {max} Symbole haben.',
				failToGenerateMonthlyReport: `Es konnte kein Bericht für den Zeitraum erstellt werden:`
			},
			changeVersion: 'Aktualisieren Sie die Anwendungsversion',
			updateVersionButton: 'Update-Version',
			autoCleanCacheLabel: 'Durch Klicken auf diese Schaltfläche können Sie die Anwendungsversion für alle Benutzer ändern.',
			autoCleanCacheHint: 'Der Cache aller Benutzer wird automatisch geleert und die Webseite wird neu geladen',
			newsletterSection: 'Neuigkeiten aktualisieren',
			newsletterLabel: 'Hier können Sie Nachrichten erstellen, bearbeiten und löschen',
			newsletterTip: 'Ziehen Sie die Nachrichten per Drag-and-Drop, um ihre Anzeigereihenfolge zu ändern',
			buttons: {
				create: "Nachrichten erstellen",
				delete: "Löschen",
				edit: "Bearbeiten",
				saveOrder: "Speichern Sie die Nachrichtenreihenfolge",
				close: 'Schließen',
				save: "Speichern",
				archive: "Archivieren",
				unarchive: "Archiv aufheben",
				promote: "Befördern",
				monthlyReport: 'Monatsbericht'
			},
			selectPlatformForm: 'Wählen Sie einen Plattformtyp:',
			topicForm: 'Thema:',
			titleForm: 'Titel:',
			messageForm: 'Nachricht:',
			redirectButtonForm: 'Text der Weiterleitungsschaltfläche:',
			redirectButtonUrlForm: 'Weiterleitungs-URL:',
			commonHintForm: 'Dieses Feld ist obligatorisch, kann nur auf Englisch sein und muss eine Textlänge zwischen {min} und {max} Symbolen haben.',
			redirectButtonHintForm: 'Dieses Feld ist obligatorisch und muss eine Textlänge zwischen {min} und {max} Symbolen haben.',
			selectHintForm: 'Das Feld ist obligatorisch. Sie müssen eine der beiden Optionen auswählen.',
			exampleTopic: 'Beispielthema...',
			exampleTitle: 'Beispieltitel...',
			exampleMessage: 'Beispielnachricht...',
			exampleButtonRedirect: 'Beispieltext für eine Weiterleitungsschaltfläche...',
			successfullyGeneratedMonthlyReport: 'Bericht für den Zeitraum erfolgreich erstellt:',
			mustSelectDates: 'Um den Monatsbericht zu generieren, müssen Sie im Datumsfilter Start- und Enddatum auswählen.'
		},
		manageLabels: 'Etiketten verwalten',
		usersManagement: {
			title: 'Benutzer verwalten',
			form: {
				id: 'Ausweis',
				fullName: 'Vollständiger Name',
				email: 'E-Mail',
				company: 'Unternehmen',
				jobTitle: 'Berufsbezeichnung',
				createdDate: 'Erstelldatum',
				requestDate: 'Antragsdatum',
				lastLoginDate: 'Datum des letzten Logins',
				status: 'Status',
				actions: 'Aktionen',
				popUp: {
					areYouSureApprove: "Sind Sie sicher, dass Sie den Benutzer genehmigen möchten? - ",
					areYouSureSetPending: " - kann sich nicht anmelden. Sind Sie sicher?",
					yes: "Ja",
					no: "Nein"
				},
				successApprove: "Der Benutzer wurde erfolgreich zugelassen.",
				successPending: "Der Benutzer wurde erfolgreich auf „Ausstehend“ gesetzt.",
				successUnhalted: "Der Benutzer wurde erfolgreich entsperrt.",
				successHalted: "Der Benutzer wurde erfolgreich angehalten.",
				approve: "Genehmigen",
				setToPending: "Auf ausstehend setzen",
				setToUnhalted: 'Auf unangehalten eingestellt',
				setToHalted: "Soll gestoppt werden",
				failedEmailToApprovedUser: 'Dem genehmigten Benutzer konnte keine E-Mail gesendet werden.'
			}
		},
		surveyManagement: {
			title: 'Umfragen verwalten',
		},
		videoManagement:{
			title: 'Videos verwalten',
		},
		resourceFileManagement: {
			title: 'Ressourcendateien verwalten',
		},
		promotionsManagement: {
			title: 'Werbeaktionen verwalten',
		},
		analytics: {
			title: 'Berichterstattung'
		}
	},
	[LANGUAGE.fr.short]: {
		landingPage: {
			title: 'Page de destination',
			imageUploadTitle: 'Changer l\'image de la page de destination',
			imageHint: `L'image doit être de très bonne qualité au format webp, avec une hauteur comprise entre 1065px - 858px et une largeur comprise entre 1728px - 1280px.`,
			label: `Téléchargez votre image et cliquez sur le bouton Appliquer`,
			apply: 'Appliquer',
			errors: {
				width: 'L\'image n\'a pas une largeur comprise entre 1728px et 1280px.',
				height: 'L\'image n\'a pas une hauteur comprise entre 1065px et 858px.',
				imageType: 'L\'image n\'est pas le bon type de fichier.',
				fileType: 'Le fichier n\'est pas le bon type.',
				notEmpty: `Le champ ne peut pas être vide.`,
				notValidUrl: 'Ce n\'est pas une URL valide.',
				notValidEmail: 'Ce n\'est pas une adresse e-mail valide.',
				notValidLength: 'Le champ doit être compris entre les symboles {min} et {max}.',
				notValidWidth: 'L\'image n\'a pas au moins {min}px de largeur.',
				notValidHeight: 'L\'image n\'a pas au moins {min}px de hauteur.',
				notEnoughSelected: 'Vous devez sélectionner au moins {min} options.',
				tooMuchSelected: 'Vous devez sélectionner au maximum {max} options.',
				dimensions: 'L\'image n\'a pas les bonnes dimensions. Doit être 1920x535 ou 1200x338.',
				mobileDimensions: 'L\'image n\'a pas les bonnes dimensions. Doit être 480x400 ou 460x400.',
				notUnique: 'Il ne peut pas y avoir d\'éléments répétés.',
				maxLength: 'Le champ doit comporter au maximum {max} symboles.',
				failToGenerateMonthlyReport: `Impossible de générer un rapport pour la période:`
			},
			changeVersion: 'Mettre à jour la version de l\'application',
			updateVersionButton: 'Version de mise à jour',
			autoCleanCacheLabel: 'En cliquant sur ce bouton, vous pouvez modifier la version de l\'application pour tous les utilisateurs.',
			autoCleanCacheHint: 'Il nettoiera automatiquement le cache de tous les utilisateurs et rechargera la page Web',
			newsletterSection: 'Mettre à jour les nouvelles',
			newsletterLabel: 'Ici, vous pouvez créer, modifier et supprimer des actualités',
			newsletterTip: 'Glissez et déposez les actualités pour modifier leur ordre d\'affichage',
			buttons: {
				create: "Créer des actualités",
				delete: "Supprimer",
				edit: "Modifier",
				saveOrder: "Enregistrer la commande de nouvelles",
				close: 'Fermer',
				save: "Sauvegarder",
				archive: "Archiver",
				unarchive: "Déarchiver",
				promote: "Promouvoir",
				monthlyReport: 'Rapport mensuel'
			},
			selectPlatformForm: 'Sélectionnez un type de plateforme:',
			topicForm: 'Sujet:',
			titleForm: 'Titre:',
			messageForm: 'Message:',
			redirectButtonForm: 'Texte du bouton de redirection:',
			redirectButtonUrlForm: 'URL de redirection:',
			commonHintForm: 'Ce champ est obligatoire, ne peut être qu\'en anglais et doit avoir une longueur de texte comprise entre les symboles {min} et {max}.',
			redirectButtonHintForm: 'Ce champ est obligatoire et doit avoir une longueur de texte comprise entre les symboles {min} et {max}.',
			selectHintForm: 'Ce champ est obligatoire. Vous devez sélectionner l\'une des deux options.',
			exampleTopic: 'Exemple de sujet...',
			exampleTitle: 'Exemple de titre...',
			exampleMessage: 'Exemple de message...',
			exampleButtonRedirect: 'Exemple de texte de bouton de redirection...',
			successfullyGeneratedMonthlyReport: 'Rapport généré avec succès pour la période:',
			mustSelectDates: 'Vous devez sélectionner les dates de début et de fin dans le filtre de dates pour générer le rapport mensuel.'
		},
		manageLabels: 'Gérer les étiquettes',
		usersManagement: {
			title: 'Gérer les utilisateurs',
			form: {
				id: 'Identifiant',
				fullName: 'Nom et prénom',
				email: 'E-mail',
				company: 'Entreprise',
				jobTitle: 'Titre d\'emploi',
				createdDate: 'Date de création',
				requestDate: 'Date de demande',
				lastLoginDate: 'Date de dernière connexion',
				status: 'Statut',
				actions: 'Actes',
				popUp: {
					areYouSureApprove: "Êtes-vous sûr de vouloir approuver l'utilisateur -",
					areYouSureSetPending: " - ne pourra pas se connecter. Êtes-vous sûr ?",
					yes: "Oui",
					no: "Non"
				},
				successApprove: "L'utilisateur a été approuvé avec succès.",
				successPending: "L'utilisateur a été correctement défini comme étant en attente.",
				successUnhalted: "L'utilisateur a été relancé avec succès.",
				successHalted: "L'utilisateur a été arrêté avec succès.",
				approve: "Approuver",
				setToPending: "Définir comme en attente",
				setToUnhalted: 'Réglé sur sans interruption',
				setToHalted: "Prêt à être arrêté",
				failedEmailToApprovedUser: 'Échec de l\'envoi d\'un e-mail à l\'utilisateur approuvé.'
			}
		},
		surveyManagement: {
			title: 'Gérer les enquêtes',
		},
		videoManagement:{
			title: 'Gérer les vidéos',
		},
		resourceFileManagement: {
			title: 'Gérer les fichiers de ressources',
		},
		promotionsManagement: {
			title: 'Gérer les promotions',
		},
		analytics: {
			title: 'Rapport'
		}
	},
	[LANGUAGE.it.short]: {
		landingPage: {
			title: 'Pagina di destinazione',
			imageUploadTitle: 'Modifica l\'immagine della pagina di destinazione',
			imageHint: `L'immagine deve essere di ottima qualità in formato webp, con un'altezza compresa tra 1065px - 858px e una larghezza compresa tra 1728px - 1280px.`,
			label: `Carica la tua immagine e fai clic sul pulsante Applica`,
			apply: 'Fare domanda a',
			errors: {
				width: 'L\'immagine non ha una larghezza compresa tra 1728px e 1280px.',
				height: 'L\'immagine non ha un\'altezza compresa tra 1065px e 858px.',
				imageType: 'L\'immagine non è del tipo di file corretto.',
				fileType: 'Il file non è del tipo corretto.',
				notEmpty: `Il campo non può essere vuoto.`,
				notValidUrl: 'Non è un URL valido.',
				notValidEmail: 'Non è un indirizzo email valido.',
				notValidLength: 'Il campo deve essere compreso tra i simboli {min} e {max}.',
				notValidWidth: 'L\'immagine non ha almeno {min}px di larghezza.',
				notValidHeight: 'L\'immagine non ha almeno {min}px di altezza.',
				notEnoughSelected: 'Devi selezionare almeno {min} opzioni.',
				tooMuchSelected: 'Devi selezionare al massimo {max} opzioni.',
				dimensions: 'L\'immagine non ha le dimensioni corrette. Dovrebbe essere 1920x535 o 1200x338.',
				mobileDimensions: 'L\'immagine non ha le dimensioni corrette. Dovrebbe essere 480x400 o 460x400.',
				notUnique: 'Non possono esserci elementi ripetuti.',
				maxLength: 'Il campo deve avere al massimo {max} simboli.',
				failToGenerateMonthlyReport: `Impossibile generare un report per il periodo:`
			},
			changeVersion: 'Aggiorna la versione dell\'applicazione',
			updateVersionButton: 'versione aggiornata',
			autoCleanCacheLabel: 'Facendo clic su questo pulsante è possibile modificare la versione dell\'applicazione per tutti gli utenti.',
			autoCleanCacheHint: 'Pulirà automaticamente la cache di tutti gli utenti e ricaricherà la pagina web',
			newsletterSection: 'Aggiorna notizie',
			newsletterLabel: 'Qui puoi creare, modificare ed eliminare notizie',
			newsletterTip: 'Trascina e rilascia le notizie per modificarne l\'ordine di visualizzazione',
			buttons: {
				create: "Crea notizie",
				delete: "Eliminare",
				edit: "Modificare",
				saveOrder: "Salva l'ordine delle notizie",
				close: 'Vicino',
				save: "Salva",
				archive: "Archivia",
				unarchive: "Disarchivia",
				promote: "Promuovere",
				monthlyReport: 'Rapporto mensile'
			},
			selectPlatformForm: 'Seleziona un tipo di piattaforma:',
			topicForm: 'Argomento:',
			titleForm: 'Titolo:',
			messageForm: 'Messaggio:',
			redirectButtonForm: 'Testo del pulsante di reindirizzamento:',
			redirectButtonUrlForm: 'URL di reindirizzamento:',
			commonHintForm: 'Questo campo è obbligatorio, può essere solo in inglese e deve avere una lunghezza del testo compresa tra {min} e {max} simboli.',
			redirectButtonHintForm: 'Questo campo è obbligatorio e deve avere una lunghezza del testo compresa tra {min} e {max} simboli.',
			selectHintForm: 'Questo campo è obbligatorio. È necessario selezionare una di entrambe le opzioni.',
			exampleTopic: 'Argomento di esempio...',
			exampleTitle: 'Exemple de titre...',
			exampleMessage: 'Messaggio di esempio...',
			exampleButtonRedirect: 'Esempio di testo del pulsante di reindirizzamento...',
			successfullyGeneratedMonthlyReport: 'Report generato correttamente per il periodo:',
			mustSelectDates: 'È necessario selezionare le date di inizio e fine dal filtro data per generare il report mensile'
		},
		manageLabels: 'Gestisci etichette',
		usersManagement: {
			title: 'Gestisci utenti',
			form: {
				id: 'ID',
				fullName: 'Nome e cognome',
				email: 'E-mail',
				company: 'Azienda',
				jobTitle: 'Titolo di lavoro',
				createdDate: 'Data di creazione',
				requestDate: 'Data di richiesta',
				lastLoginDate: 'Data dell\'ultimo accesso',
				status: 'Stato',
				actions: 'Azioni',
				popUp: {
					areYouSureApprove: "Sei sicuro di voler approvare l'utente - ",
					areYouSureSetPending: " - non sarà in grado di effettuare l'accesso. Sei sicuro?",
					yes: "Si",
					no: "No"
				},
				successApprove: "L'utente è stato approvato con successo.",
				successPending: "L'utente è stato impostato correttamente in sospeso.",
				successUnhalted: "L'utente è stato ripristinato con successo",
				successHalted: "L'utente è stato arrestato con successo.",
				approve: "Approva",
				setToPending: "Imposta in sospeso",
				setToUnhalted: 'Impostato su non arrestato',
				setToHalted: "Impostato su arrestato",
				failedEmailToApprovedUser: 'Impossibile inviare un\'e-mail all\'utente approvato.'
			}
		},
		surveyManagement: {
			title: 'Gestisci sondaggi',
		},
		videoManagement:{
			title: 'Gestisci video',
		},
		resourceFileManagement: {
			title: 'Gestisci file di risorse',
		},
		promotionsManagement: {
			title: 'Gestisci promozioni',
		},
		analytics: {
			title: 'Reportistica'
		}
	},
	[LANGUAGE.ja.short]: {
		landingPage: {
			title: 'ランディングページ',
			imageUploadTitle: 'ランディングページの画像を変更する',
			imageHint: `画像は、高さが 1065px ～ 858px、幅が 1728px ～ 1280px の webp 形式で非常に高品質である必要があります。`,
			label: `画像をアップロードして「適用」ボタンをクリックします`,
			apply: '適用する',
			errors: {
				width: '画像の幅が 1728px から 1280px の間にありません。',
				height: '画像の高さが 1065px から 858px の間にありません。',
				imageType: '画像のファイル形式が正しくありません',
				fileType: 'ファイルの形式が正しくありません。',
				notEmpty: `フィールドを空にすることはできません。`,
				notValidUrl: '有効な URL ではありません。',
				notValidEmail: '有効なメールアドレスではありません。',
				notValidLength: 'フィールドは {min} と {max} の記号の間にある必要があります。',
				notValidWidth: '画像の幅が少なくとも {min}px ありません。',
				notValidHeight: '画像の高さが少なくとも {min}px ありません。',
				notEnoughSelected: '最低 {min} のオプションを選択する必要があります。',
				tooMuchSelected: '最大 {max} のオプションを選択する必要があります。',
				dimensions: '画像の寸法が正しくありません。1920x535 または 1200x338 である必要があります。',
				mobileDimensions: '画像の寸法が正しくありません。480x400 または 460x400 である必要があります。',
				notUnique: '繰り返し項目はありません。',
				maxLength: 'フィールドは {max} の記号以下である必要があります。',
				failToGenerateMonthlyReport: `期間のレポートを生成できません:`
			},
			changeVersion: 'アプリケーションのバージョンを更新する',
			updateVersionButton: 'バージョンを更新する',
			autoCleanCacheLabel: 'このボタンをクリックすると、すべてのユーザーのアプリケーションのバージョンを変更できます。',
			autoCleanCacheHint: 'すべてのユーザーのキャッシュを自動消去し、Web ページをリロードします。',
			newsletterSection: 'ニュースを更新',
			newsletterLabel: 'ここでニュースを作成、編集、削除できます',
			newsletterTip: 'ニュースをドラッグ＆ドロップして表示順序を変更します',
			buttons: {
				create: "ニュースを作成する",
				delete: "消去",
				edit: "編集",
				saveOrder: "ニュースの注文を保存する",
				close: '近い',
				save: "保存",
				archive: "アーカイブ",
				unarchive: "アーカイブ解除",
				promote: "昇進",
				monthlyReport: '月報'
			},
			selectPlatformForm: 'プラットフォームのタイプを選択します:',
			topicForm: 'トピック:',
			titleForm: 'タイトル:',
			messageForm: 'メッセージ:',
			redirectButtonForm: 'リダイレクトボタンのテキスト:',
			redirectButtonUrlForm: 'リダイレクト URL:',
			commonHintForm: 'このフィールドは必須で、英語のみを使用でき、テキストの長さは {min} 記号と {max} 記号の間である必要があります。',
			redirectButtonHintForm: 'このフィールドは必須であり、テキストの長さは {min} 記号と {max} 記号の間である必要があります。',
			selectHintForm: 'このフィールドは必須です。 両方のオプションのいずれかを選択する必要があります。',
			exampleTopic: 'トピックの例...',
			exampleTitle: 'タイトル例…',
			exampleMessage: 'メッセージの例...',
			exampleButtonRedirect: 'リダイレクトボタンのテキストの例...',
			successfullyGeneratedMonthlyReport: '期間のレポートが正常に生成されました:',
			mustSelectDates: '月次レポートを生成するには、日付フィルターから開始日と終了日を選択する必要があります。'
		},
		manageLabels: 'ラベルの管理',
		usersManagement: {
			title: 'ユーザーの管理',
			form: {
				id: 'ID',
				fullName: 'フルネーム',
				email: 'メール',
				company: '会社',
				jobTitle: '役職',
				createdDate: '作成日',
				requestDate: 'リクエスト日',
				lastLoginDate: '最終ログイン日',
				status: '状態',
				actions: 'アクション',
				popUp: {
					areYouSureApprove: "ユーザーを承認してもよろしいですか - ",
					areYouSureSetPending: " - はサインインできません。よろしいですか?",
					yes: "はい",
					no: "いいえ"
				},
				successApprove: "ユーザーは正常に承認されました。",
				successPending: "ユーザーは正常に保留に設定されました。",
				successUnhalted: "ユーザーの停止は正常に解除されました",
				successHalted: "ユーザーは正常に停止されました。",
				approve: "承認",
				setToPending: "保留に設定",
				setToUnhalted: '停止解除に設定',
				setToHalted: "停止に設定",
				failedEmailToApprovedUser: '承認されたユーザーにメールを送信できませんでした。'
			}
		},
		surveyManagement: {
			title: 'アンケートの管理',
		},
		videoManagement:{
			title: 'ビデオの管理',
		},
		resourceFileManagement: {
			title: 'リソースファイルの管理',
		},
		promotionsManagement: {
			title: 'プロモーションの管理',
		},
		analytics: {
			title: 'レポート'
		}
	},
	[LANGUAGE.es.short]: {
		landingPage: {
			title: 'Página de destino',
			imageUploadTitle: 'Cambiar la imagen de la página de destino',
			imageHint: `La imagen debe ser de muy buena calidad en formato webp, con una altura entre 1065px - 858px y un ancho entre 1728px - 1280px.`,
			label: `Sube tu imagen y haz clic en el botón Aplicar`,
			apply: 'Aplicar',
			errors: {
				width: 'La imagen no tiene un ancho entre 1728px y 1280px.',
				height: 'La imagen no tiene una altura entre 1065px y 858px.',
				imageType: 'La imagen no es del tipo de archivo correcto.',
				fileType: 'El archivo no es del tipo correcto.',
				notEmpty: `El campo no puede estar vacío.`,
				notValidUrl: 'No es una URL válida.',
				notValidEmail: 'No es un correo electrónico válido.',
				notValidLength: 'El campo debe tener entre {min} y {max} símbolos.',
				notValidWidth: 'La imagen no tiene al menos {min}px de ancho.',
				notValidHeight: 'La imagen no tiene al menos {min}px de alto.',
				notEnoughSelected: 'Debes seleccionar al menos {min} opciones.',
				tooMuchSelected: 'Debes seleccionar un máximo de {max} opciones.',
				dimensions: 'La imagen no tiene las dimensiones correctas. Debe ser 1920x535 o 1200x338.',
				mobileDimensions: 'La imagen no tiene las dimensiones correctas. Debe ser 480x400 o 460x400.',
				notUnique: 'No puede haber elementos repetidos.',
				maxLength: 'El campo debe tener como máximo {max} símbolos.',
				failToGenerateMonthlyReport: `No se pudo generar el informe para el período:`
			},
			changeVersion: 'Actualizar la versión de la aplicación',
			updateVersionButton: 'actualizar versión',
			autoCleanCacheLabel: 'Al hacer clic en este botón, puedes cambiar la versión de la aplicación para todos los usuarios.',
			autoCleanCacheHint: 'Limpiará automáticamente la caché de todos los usuarios y recargará la página web',
			newsletterSection: 'Actualizar noticias',
			newsletterLabel: 'Aquí puedes crear, editar y eliminar noticias',
			newsletterTip: 'Arrastra y suelta las noticias para cambiar su orden de visualización',
			buttons: {
				create: "Crear noticias",
				delete: "Eliminar",
				edit: "Editar",
				saveOrder: "Guardar el orden de las noticias",
				close: 'Cerrar',
				save: "Guardar",
				archive: "Archivar",
				unarchive: "Desarchivar",
				promote: "Promover",
				monthlyReport: 'Informe mensual'
			},
			selectPlatformForm: 'Selecciona un tipo de plataforma:',
			topicForm: 'Tema:',
			titleForm: 'Título:',
			messageForm: 'Mensaje:',
			redirectButtonForm: 'Texto del botón de redirección:',
			redirectButtonUrlForm: 'URL de redirección:',
			commonHintForm: 'Este campo es obligatorio, solo puede estar en inglés y debe tener una longitud de texto entre {min} y {max} símbolos.',
			redirectButtonHintForm: 'Este campo es obligatorio y debe tener una longitud de texto entre {min} y {max} símbolos.',
			selectHintForm: 'Este campo es obligatorio. Debes seleccionar una de las dos opciones.',
			exampleTopic: 'Tema de ejemplo...',
			exampleTitle: 'Título de ejemplo...',
			exampleMessage: 'Mensaje de ejemplo...',
			exampleButtonRedirect: 'Texto de ejemplo del botón de redirección...',
			successfullyGeneratedMonthlyReport: 'Informe generado correctamente para el período:',
			mustSelectDates: ''
		},
		manageLabels: 'Gestionar etiquetas',
		usersManagement: {
			title: 'Gestionar usuarios',
			form: {
				id: 'ID',
				fullName: 'Nombre completo',
				email: 'Correo electrónico',
				company: 'Empresa',
				jobTitle: 'Título del trabajo',
				createdDate: 'Fecha de creación',
				requestDate: 'Fecha de solicitud',
				lastLoginDate: 'Fecha del último inicio de sesión',
				status: 'Estado',
				actions: 'Acciones',
				popUp: {
					areYouSureApprove: "¿Estás seguro de que quieres aprobar al usuario - ",
					areYouSureSetPending: " - no podrá iniciar sesión. ¿Estás seguro?",
					yes: "Sí",
					no: "No"
				},
				successApprove: "El usuario ha sido aprobado correctamente.",
				successPending: "El usuario ha sido configurado correctamente como pendiente.",
				successUnhalted: "El usuario fue desconectado exitosamente",
				successHalted: "El usuario fue detenido exitosamente.",
				approve: "Aprobar",
				setToPending: "Establecer como pendiente",
				setToHalted: "Detenido",
				setToUnhalted: 'Establecer como no detenido',
				failedEmailToApprovedUser: 'No se pudo enviar un correo electrónico al usuario aprobado.'
			}
		},
		surveyManagement: {
			title: 'Gestionar encuestas',
		},
		videoManagement:{
			title: 'Gestionar videos',
		},
		resourceFileManagement: {
			title: 'Gestionar archivos de recursos',
		},
		promotionsManagement: {
			title: 'Gestionar promociones',
		},
		analytics: {
			title: 'Informes'
		}
	}
}
